import React, { Component } from 'react';
import { connect } from 'react-redux';
import Service from '../../services';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { BoardsIconInActive, GradesIcon } from '../svgIcons';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../loadingComponent';
import { getBoardsData, getBranchesLatest } from '../../store/actions';
import { userAssignedBoards } from '../../store/selectors/userAssignedBoards';
import { cloneDeep } from 'lodash';
import { baseUrlAdmin } from '../../store/apiConstants';

class BranchesApprovalHierarchy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boardIds: null,
            classIds: null,
            branchIds: null,
            sectionId: null,
            boards: [],
            classes: [],
            sections: [],
            heirarchy: [],
            branchesDD: [],
            isLoading: false
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    componentDidMount() {
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.shouldUpdateState(prevState)) {
            this.updateStateWithFilteredData();
        }
    }

    shouldUpdateState(prevState) {
        return this.state.branchIds == null && this.props.boards?.length > 0 && this.props.branchData?.length > 0 && this.state?.heirarchy?.branchIds?.length && !prevState.branchIds;
    }

    getData = () => {
        this.getUserAssignedHeirarchy();
        // this.props.getBranchesLatest();
        // this.props.getBoardsData(true);
    };

    getUserAssignedHeirarchy = () => {
        this.setState({ isLoading: true });
        const url = `${baseUrlAdmin}/settings-approvals/userAssignedBoards?approvalType=${this.props.approvalType}`;

        this.service
            .get(url, true)
            .then((res) => {
                if (res?.status && res?.res?.status) {
                    this.setState({
                        heirarchy: { branchIds: res?.res?.data?.data?.map((d) => d.branchId) || [], adminLevels: res?.res?.data?.adminUserAssignedLevelDetails || [] },

                        isLoading: false
                    });
                } else {
                    this.setState({
                        heirarchy: { branchIds: [] },
                        isLoading: false
                    });
                }
            })
            .catch((e) => {
                this.setState({ isLoading: false });
                this.toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch hierarchy data', life: 3000 });
            });
    };

    // Helper method to check if user is a teacher
    isTeacher = () => {
        // Check user type from localStorage
        const userType = localStorage.getItem('type');

        // Only if type is 'teacher', check for assignedSubjects
        if (userType === 'teacher') {
            return this.props.userInfo?.assignedSubjects && this.props.userInfo.assignedSubjects.length > 0;
        }

        // For all other types (admin, staff, etc.), return false (they get all sections)
        return false;
    }

    // Helper method to remove duplicates based on unique ID
    removeDuplicates = (array, idKey) => {
        if (!array || array.length === 0) return [];

        const seen = new Set();
        return array.filter(item => {
            const id = item[idKey];
            if (seen.has(id)) {
                return false;
            }
            seen.add(id);
            return true;
        });
    }

    // Filter branches based on user's assigned branches and hierarchy
    getFilteredBranches = () => {
        const { userInfo, branchData } = this.props;
        const { heirarchy } = this.state;

        // Start with hierarchy branches if available
        let filteredBranches = branchData;

        // If hierarchy has branches, filter by those first
        if (heirarchy?.branchIds && heirarchy.branchIds.length > 0) {
            filteredBranches = branchData.filter(branch =>
                heirarchy.branchIds.includes(branch.key)
            );
        }

        // If user is admin, return filtered branches (by hierarchy if exists)
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(filteredBranches || [], 'key');
        }

        // For non-admin users, additionally filter by assigned branches
        if (userInfo.branchs && userInfo.branchs.length > 0) {
            filteredBranches = filteredBranches.filter(branch =>
                userInfo.branchs.includes(branch.key)
            );
        }

        return this.removeDuplicates(filteredBranches, 'key');
    }

    // Filter boards based on user's assigned branches and boards
    getFilteredBoardsWithUserRole = (selectedBranchIds) => {
        const { userInfo, boards } = this.props;

        let filteredBoards = cloneDeep(boards || []);

        // If user is admin, return all boards (filtered only by selected branches if any)
        if (userInfo?.isAdmin === true) {
            // Filter by selected branches only
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }
        } else {
            // For non-admin users, filter by selected branches
            if (selectedBranchIds && selectedBranchIds.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    board.assignedBranches.some(branchId => selectedBranchIds.includes(branchId))
                );
            }

            // For teachers, additionally filter by assigned boards
            if (this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
            // For non-admin, non-teacher users, filter by assigned boards if available
            else if (!this.isTeacher() && userInfo?.boardId && userInfo?.boardId.length > 0) {
                filteredBoards = filteredBoards.filter(board =>
                    userInfo?.boardId.includes(board.boardId)
                );
            }
        }

        // Remove duplicate boards by boardId
        filteredBoards = this.removeDuplicates(filteredBoards, 'boardId');

        return filteredBoards;
    }

    // Filter sections based on user role
    getFilteredSectionsWithUserRole = (sections) => {
        const { userInfo } = this.props;

        // If user is admin, return all sections
        if (userInfo?.isAdmin === true) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If not a teacher, return all sections (no filtering needed)
        if (!this.isTeacher()) {
            return this.removeDuplicates(sections, 'sectionId');
        }

        // If teacher but no assignedSections, return empty array (no sections accessible)
        if (!userInfo?.sections || userInfo.sections.length === 0) {
            return [];
        }

        // For teachers with assignedSections, filter by assigned sections
        const filtered = sections.filter(section =>
            userInfo.sections.includes(section.sectionId)
        );

        return this.removeDuplicates(filtered, 'sectionId');
    }

    updateStateWithFilteredData() {
        const { boards, branchData } = this.props;
        const { heirarchy } = this.state;

        const branchess = branchData.filter((item) => heirarchy?.branchIds?.includes(item.key));
        const branchdIds = branchess.map((e) => e.key);

        // Use filtered boards with user role consideration
        const filteredBoards = this.getFilteredBoardsWithUserRole(branchdIds);

        if (filteredBoards.length > 0) {
            this.processFilteredBoards(filteredBoards, branchdIds);
        }
    }

    getFilteredBoards(boards, branchIds) {
        // Delegate to the new method with user role filtering
        return this.getFilteredBoardsWithUserRole(branchIds);
    }

    processFilteredBoards(filteredBoards, branchIds) {
        this.formatBoardData(filteredBoards);

        const boardIds = filteredBoards.map((e) => e.boardId);
        const filterClasses = this.getFilteredClasses(filteredBoards, boardIds[0]);
        const filterClassIds = filterClasses.map((e) => e.classId);
        let filteredSections = this.getFilteredSections(filterClasses, filterClassIds[0]);

        // Apply user role-based section filtering
        filteredSections = this.getFilteredSectionsWithUserRole(filteredSections);

        this.setNewState(filteredBoards, filterClasses, filteredSections, boardIds, filterClassIds, branchIds);
    }

    formatBoardData(boards) {
        boards.forEach((board) => {
            board?.classes?.forEach((classs) => {
                classs.className = classs.className?.includes('--') ? classs.className : `${board?.boardName} -- ${classs.className}`;
                classs.sections.forEach((sec) => {
                    sec.sectionName = sec?.sectionName?.includes('--') ? sec.sectionName : `${classs.className} -- ${sec.sectionName}`;
                });
            });
        });
    }

    getFilteredClasses(boards, boardId) {
        const classes = boards
            ?.filter((board) => board.boardId === boardId)
            ?.map((e) => e.classes)
            .flat();

        // Remove duplicate classes by classId
        return this.removeDuplicates(classes, 'classId');
    }

    getFilteredSections(classes, classId) {
        const sections = classes
            .filter((e) => e.classId === classId)
            ?.map((e) => e.sections)
            .flat();

        // Remove duplicate sections by sectionId
        return this.removeDuplicates(sections, 'sectionId');
    }

    setNewState(filteredBoards, filterClasses, filteredSections, boardIds, filterClassIds, branchIds) {
        const sectionIds = filteredSections?.map((e) => e.sectionId);
        const selectedSectionName = filteredSections.length > 0 ? filteredSections[0].sectionName : '';
        const selectedSectionId = sectionIds?.length > 0 ? sectionIds[0] : '';

        // Get filtered branches for the dropdown
        const filteredBranchesDD = this.getFilteredBranches();

        this.setState(
            {
                branches: filterClasses[0].branches,
                branchIds: [branchIds[0]],
                boards: filteredBoards,
                boardIds: [boardIds[0]],
                classes: filterClasses,
                classIds: [filterClassIds[0]],
                selectedClassName: filterClasses[0].className,
                selectedbranchName: filterClasses[0].branches?.[0]?.branchName,
                sections: filteredSections,
                sectionId: selectedSectionId,
                selectedsectionName: selectedSectionName,
                branchesDD: filteredBranchesDD
            },
            this.setDropdownsData
        );
    }

    onChangeBranch = (branchIds) => {
        // Use filtered boards with user role consideration
        const filteredBoards = this.getFilteredBoardsWithUserRole([branchIds]);
        this.formatBoardData(filteredBoards);

        this.setState(
            {
                branchIds: [branchIds],
                boards: filteredBoards,
                classes: [],
                boardIds: '',
                classIds: '',
                branches: [],
                sections: [],
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeBoard = (boardIds) => {
        const filteredClasses = this.state.boards.filter((board) => boardIds.includes(board.boardId)).flatMap((board) => board.classes);

        // Remove duplicate classes
        const uniqueClasses = this.removeDuplicates(filteredClasses, 'classId');

        this.setState(
            {
                classes: uniqueClasses,
                boardIds,
                classIds: '',
                branches: [],
                sections: [],
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeClass = (classIds) => {
        const filterClasses = this.state.classes?.filter((classs) => classIds?.includes(classs?.classId));
        let sections = filterClasses?.flatMap((fClass) => fClass.sections?.filter((sec) => this.state.branchIds?.includes(sec?.branchId)));

        // Apply user role-based section filtering
        sections = this.getFilteredSectionsWithUserRole(sections || []);

        this.setState(
            {
                classIds,
                sections,
                sectionId: '',
                selectedsectionName: ''
            },
            this.setDropdownsData
        );
    };

    onChangeSection = (sectionId) => {
        const selectedSection = this.state.sections?.find((section) => section.sectionId === sectionId);
        const selectedsectionName = selectedSection?.sectionName || '';

        this.setState(
            {
                sectionId,
                selectedsectionName
            },
            this.setDropdownsData
        );
    };

    setDropdownsData = () => {
        const { boardIds, classIds, branchIds, sectionId, heirarchy } = this.state;
        this.props.setValues({
            boardIds,
            classIds,
            branchIds,
            sectionId,
            heirarchy
        });
    };

    render() {
        const { branchesDD, branchIds, boards, boardIds, classes, classIds, sections, sectionId, isLoading } = this.state;
        const { selectedValue } = this.props;
        const isDisabled = selectedValue === 2;

        // Extract single branchId for dropdown display (branchIds is stored as array)
        const selectedBranchId = Array.isArray(branchIds) ? branchIds[0] : branchIds;

        return (
            <div>
                <div>
                    <div className="grid m-2">
                        <div className="col-3">
                            <ClassetDropdown
                                required={true}
                                label="Branch"
                                // icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder="Select Branch"
                                options={branchesDD || []}
                                value={selectedBranchId}
                                onChange={(e) => this.onChangeBranch(e.value)}
                                optionLabel="name"
                                optionValue="key"
                                disabled={isDisabled}
                            />
                        </div>
                        {/* <div className="col-3">
                            <ClassetMultiSelect
                                label="Board"
                                icon={<BoardsIconInActive height={16.5} width={19.5} />}
                                placeholder="Select Board"
                                options={boards || []}
                                value={boardIds}
                                onChange={(e) => this.onChangeBoard(e.value)}
                                optionLabel="boardName"
                                optionValue="boardId"
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetMultiSelect
                                label="Grade"
                                icon={<GradesIcon />}
                                placeholder="Select (Board - Grade)"
                                options={classes || []}
                                value={classIds}
                                onChange={(e) => this.onChangeClass(e.value)}
                                optionLabel="className"
                                optionValue="classId"
                                disabled={isDisabled}
                            />
                        </div>
                        <div className="col-3">
                            <ClassetDropdown
                                label="Section"
                                icon={<GradesIcon />}
                                placeholder="Select (Board - Grade - Section)"
                                options={sections || []}
                                value={sectionId}
                                onChange={(e) => this.onChangeSection(e.value)}
                                optionLabel="sectionName"
                                optionValue="sectionId"
                                disabled={isDisabled}
                            />
                        </div> */}
                    </div>
                </div>
                <Toast ref={this.toast} position="bottom-right" />
                {isLoading && <LoadingComponent />}
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    branchData: state.branchDataLatest?.data?.data?.filter((each) => each.level === 1) || [],
    permissionIds: state.currentUserPerms?.permissionIds,
    userInfo: state.currentUserPerms?.userInfo || {}
});

export default connect(mapStatesToProps, { getBoardsData, getBranchesLatest })(BranchesApprovalHierarchy);
